export default __webpack_public_path__ + "static/media/popcorn-pieces-08.dbf7349c.png";